import {
  isLeadContactEnrichmentPayload,
  normalizeLeadDerivedColumns,
} from './EnrichmentGrid.helpers';

function formatLeadContactResult(derivedColumns) {
  const entries = normalizeLeadDerivedColumns(derivedColumns);
  return entries
    .map(({ name, values }) => `${name}: ${values.join(', ')}`)
    .join('\n');
}

function formatMissingAiDetail(chargedUnits) {
  const chargeStatement = chargedUnits > 0
    ? `You were charged ${chargedUnits} ${chargedUnits === 1 ? 'credit' : 'credits'}.`
    : 'You were not charged.';
  return `No answer was returned. ${chargeStatement} Try a different prompt.`;
}

export function classifySingleAiEnrichment(payload = {}) {
  const summary = String(payload.summary || '').trim();
  const leadContactResult = formatLeadContactResult(payload.derived_columns);
  const identity = {summary, resultId: payload.result_id};
  if (isLeadContactEnrichmentPayload(payload) && leadContactResult) {
    return {...identity, status: 'success', result: leadContactResult, title: 'AI insight'};
  }
  if (!summary) {
    const chargedUnits = Number(payload.charged_units);
    return {
      ...identity, status: 'missing', result: '', title: 'No AI answer', chargedUnits,
      detail: formatMissingAiDetail(chargedUnits),
    };
  }
  return {summary, status: 'success', result: summary, title: 'AI insight'};
}
